import { styled } from '@linaria/react';
import { fonts, layout, primitives, semantic, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: ${space['space-1200']};
  padding: ${space['space-600']} 0;

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: ${space['space-1000']} ${space['space-2000']} ${space['space-600']};
  }
`;

export const LogoImg = styled.img`
  max-height: 56px;
  max-width: 100%;
  object-fit: contain;
`;

export const NameText = styled.span`
  font-family: ${fonts.heading};
  font-size: ${fonts.size.xl};
  font-weight: ${fonts.weight.medium};
  color: ${semantic.text.primary};
  letter-spacing: ${primitives.typography.tracking.normal};

  @media (min-width: ${layout.desktopBreakpoint}) {
    font-size: ${fonts.size['2xl']};
  }
`;
